import InAppBrowserWrapper, {
  InAppBrowserOptionsType,
  InAppBrowserResult,
} from '@/util/inAppBrowser/InAppBrowserWrapper'
import I18n from '@/locales/I18n'

/**
 * Youtubeを表示する際にInAppBrowserに指定するオプション。
 */
const defaultOptions: InAppBrowserOptionsType = {
  /**
   * インライン再生を許可する
   */
  allowInlineMediaPlayback: 'yes',
  /**
   * 自動再生を有効にするために、ユーザーアクションなしで、動画を再生可能にする
   */
  mediaPlaybackRequiresUserAction: 'no',
}

/**
 * Youtube動画をInAppBrowserで開くための機能を提供する。
 * iOSの場合に、YouTube Player API for iframe Embeds を利用して動画再生ができない問題があるため、
 * このクラスを利用する。
 *
 * @see https://stackoverflow.com/questions/27827796/youtube-iframe-file-protocol-error-using-cordova
 * @see https://developers.google.com/youtube/iframe_api_reference
 *
 */
export default class InAppYoutubeBrowser extends InAppBrowserWrapper {
  /**
   * YoutubeをInAppBrowserで開く。
   *
   * @param youtubeId Youtube動画ID
   * @param onClose InAppBrowser が閉じた際に呼び出されるコールバック関数を指定する
   * @param delegateSystem システム標準のブラウザを利用して表示時するかどうか。
   * このパラメタにtrueを指定した場合、Youtubeアプリ、または、システム標準のブラウザでYoutubeを開く。
   */
  public showYoutube(
    youtubeId: string,
    onClose?: (result: InAppBrowserResult) => void,
    delegateSystem = false,
  ) {
    if (delegateSystem) {
      super.open(`https://www.youtube.com/embed/${youtubeId}`, '_system', defaultOptions, onClose)
    } else {
      super.open(
        InAppYoutubeBrowser.makeEmbedYoutubeUrl(youtubeId),
        '_blank',
        defaultOptions,
        onClose,
      )
    }
  }

  /**
   * 埋め込み用 HTTPS HTML の URL を返す
   * 事前にサーバーに `youtube.html` を置くこと
   */
  static makeEmbedYoutubeUrl(youtubeId: string) {
    return `${process.env.VUE_APP_YOUTUBE_EMBED_HTML_URL}?videoId=${youtubeId}&lang=${I18n.locale}`
  }
}
